import { render, staticRenderFns } from "./DoctorBulkImport.vue?vue&type=template&id=0e8b8655&scoped=true&lang=pug"
import script from "./DoctorBulkImport.vue?vue&type=script&lang=js"
export * from "./DoctorBulkImport.vue?vue&type=script&lang=js"
import style0 from "./DoctorBulkImport.vue?vue&type=style&index=0&id=0e8b8655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b8655",
  null
  
)

export default component.exports